const BIONIC_ATTR = 'data-bionic'

// Elements whose text content should never be bionic-ized.
// Add [data-no-bionic] to any element in the app to opt its subtree out.
const SKIP_TAGS = new Set([
  'INPUT',
  'TEXTAREA',
  'SELECT',
  'BUTTON',
  'SCRIPT',
  'STYLE',
  'OPTION',
  'NOSCRIPT',
  'CODE',
  'PRE',
])

function fixationLength(word: string): number {
  if (word.length <= 3) return 1
  return Math.ceil(word.length * 0.45)
}

export function applyBionicReading(root: Element): void {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!(node.textContent ?? '').trim()) return NodeFilter.FILTER_REJECT
      // Skip already-processed nodes and any opted-out subtrees
      // (data-no-bionic = developer escape hatch; contenteditable = WYSIWYG editors)
      const parent = (node as Text).parentElement
      if (parent?.closest(`[${BIONIC_ATTR}], [data-no-bionic], [contenteditable], svg`)) return NodeFilter.FILTER_REJECT
      if (parent?.tagName && SKIP_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT
      return NodeFilter.FILTER_ACCEPT
    },
  })

  const nodes: Text[] = []
  let n: Node | null
  while ((n = walker.nextNode())) nodes.push(n as Text)

  for (const textNode of nodes) {
    const text = textNode.nodeValue ?? ''
    const span = document.createElement('span')
    span.setAttribute(BIONIC_ATTR, '1')

    for (const token of text.split(/(\s+)/)) {
      if (!token) continue
      if (/^\s+$/.test(token)) {
        span.appendChild(document.createTextNode(token))
      } else {
        const fixLen = fixationLength(token)
        const b = document.createElement('b')
        b.textContent = token.slice(0, fixLen)
        span.appendChild(b)
        span.appendChild(document.createTextNode(token.slice(fixLen)))
      }
    }

    textNode.parentNode?.replaceChild(span, textNode)
  }
}

export function removeBionicReading(root: Element): void {
  for (const el of root.querySelectorAll(`[${BIONIC_ATTR}]`)) {
    el.parentNode?.replaceChild(document.createTextNode(el.textContent ?? ''), el)
  }
}
